import React from "react";
import { cn } from "../../../common/u1/cn";
import { replaceClaimWithAccess } from "../../../../utils/Helper";
import { sectionLabel, relativeTime } from "./notificationCopy";

/* One row in the notifications drawer — the design's `.nitem`. */
export const NotificationItem = ({ notification, onSelect = () => {}, className = "" }) => {
  const unread = !notification?.is_read;

  return (
    <li className="list-none">
      <button
        type="button"
        onClick={() => onSelect(notification)}
        aria-label={notification?.message}
        className={cn(
          "block w-full rounded-[10px] border border-[#e5dfd2] p-3.5 text-left",
          "transition-colors hover:border-[var(--coral)]",
          unread ? "bg-[var(--unread-bg)]" : "bg-white",
          className
        )}
      >
        <span className="mb-1.5 flex items-center gap-2">
          <span className="rounded-full border border-[#e5dfd2] bg-[#f5f1e8] px-2 py-[3px] text-[10px] font-bold uppercase tracking-[.04em] text-[var(--ink-2)] font-sans">
            {sectionLabel(notification?.type)}
          </span>
          <span className="ml-auto text-[12px] text-[var(--muted)] font-sans">
            {relativeTime(notification?.created_at)}
          </span>
          {/* Unread is already carried by the row's ground; this is the same
              signal the dashboard timeline uses, so the two agree. */}
          {unread && (
            <span aria-hidden="true" className="h-[7px] w-[7px] shrink-0 rounded-full bg-[var(--coral)]" />
          )}
        </span>

        <span className="block text-[14px] leading-[1.45] text-[var(--ink-2)] font-sans">
          {replaceClaimWithAccess(notification?.message)}
        </span>
      </button>
    </li>
  );
};

export default NotificationItem;
